import { withAsyncLoading } from "../../Components/Templates/Loading/AsyncPageLoading";


export const ProjectsPageLoading = withAsyncLoading(async () =>
  import("./ProjectsPage").then((res) => res.ProjectsPage)
);
